import { EventEmitter, Injectable } from '@angular/core';
import { Account } from '../modules/account.interface';
import { Observable, Subject } from 'rxjs';
import { environment } from '@env/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GlobalItem, enumObject } from '../modules/Enum.interface';
import { generalApiRes } from 'app/shared/Interfaces/general-api-res.interface';
import { environment as env } from '@env/environment';
@Injectable({
  providedIn: 'root'
})
export class AccountsTreeService {

  url: string = environment.domain;
  constructor(private http: HttpClient) { }

  // ------------------------------- getting data ----------------------------

  getAccountsTree(id: number): Observable<Account[]> {
    let params = new HttpParams({ fromObject: { "companyId": id } })
    return this.http.get<Account[]>(this.url + 'AccountCategory/AccountsTree', { params })
  }
  getAccountDetailsById(id: string): Observable<any> {
    let params = new HttpParams({ fromObject: { "id": id } })
    return this.http.get<any>(this.url + 'AccountCategory/Transactions', { params })
  }
  getEnumTypes(): Observable<enumObject[]> {
    return this.http.get<enumObject[]>(this.url + 'Enums/Types')
  }
  getEnumLevels(): Observable<enumObject[]> {
    return this.http.get<enumObject[]>(this.url + 'Enums/Levels')
  }
  getListOfChildrenAccountCategories(body: any): Observable<GlobalItem[]> {
    return this.http.get<GlobalItem[]>(this.url + 'AccountCategory/ListOfChildrenAccountCategories', { params: body })
  }
  GetTaxes(id: number): Observable<generalApiRes> {
    return this.http.get<generalApiRes>(this.url + 'Taxes/GetTaxes', { params: {companyId : id} })
  }
GetRevenuesAccountPayables(id: number): Observable<any> {
  return this.http.get<any>(this.url + 'AccountReceivable/GetRevenuesAccountPayables', { params: {companyId : id} })
}
GetExpensesAccountPayables(id: number): Observable<any> {
  return this.http.get<any>(this.url + 'AccountPayable/GetExpensesAccountPayables', { params: {companyId : id} })
}
ListOfRevenuesAccounts(id: number): Observable<any> {
  return this.http.get<any>(this.url + 'AccountCategory/ListOfRevenuesAccounts', { params: {companyId : id} })
}

  // ---------------------------------------------------------------------------


  // ----------------------------- Adding Data ---------------------------------

  AddParentAccountCategory(data: any): Observable<any> {
    let body = {}
    for (const key in data) {
      if (data[key]) {
        body[key] = data[key];
      }
    }
    return this.http.post(this.url + 'AccountCategory/AddParentAccountCategory', body)
  }
  editAccount( data: any){
    // let body = {}
    // for (const key in data) {
    //   if (data[key]) {
    //     body[key] = data[key];
    //   }
    // }
    return this.http.put(this.url + `AccountCategory/Update/${data.id}`, data)
  }

  AddChildAccountCategory(data: any): Observable<any> {
    let body = {}
    for (const key in data) {
      if (data[key]) {
        body[key] = data[key];
      }
    }
    return this.http.post(this.url + 'AccountCategory/AddChildAccountCategory', body)
    // return this.http.post(this.url + 'PaymentMethod/AddPaymentMethod', body)
  }

  AddTaxs(body: any){
    return this.http.post(this.url + 'Taxes/AddTax', body)
  }

  AddAsset(body: any){
    return this.http.post(this.url + 'Assets/AddAsset', body)
  }


  // -----------------------------------------------------------------------------
  getSecondList(id: any,typeEnum): Observable<any> {
    return this.http.get<any>(this.url + `DoubleEntryAccounting/SecondList?id=${id}&type=${typeEnum}` )
  }

  postDoubleEntryAccounting(body: any): Observable<any> {
    return this.http.post<any>(this.url + 'DoubleEntryAccounting/AddDoubleEntryAccount', body)
  }

  getDoubleEntryAccounting(id: any): Observable<any> {
    return this.http.get<any>(this.url + `DoubleEntryAccounting/GetDoubleEntries/${id}`)
  }
  getDoubleEntriesById(id:string):Observable<any>{
    return this.http.get<any>(this.url+`DoubleEntryAccounting/GetDoubleEntryDetails/${id}`)
  }
  addVoucher(body: any): Observable<any> {
    return this.http.post<any>(this.url + 'DoubleEntryAccounting/AddVoucher', body)
  }

  addAccountPayable(data:any):Observable<any>{
    return this.http.post<any>(env.url+'/AccountPayable/AddAccountPayable',data)
  }
  addAccountReceivable(data:any):Observable<any>{
    return this.http.post<any>(env.url+'/AccountReceivable/AddAccountReceivable',data)
  }
  deleteAccount(id:any){
    return this.http.delete(this.url + 'AccountCategory/Delete', {params:{id:id}})
  }
  getListOfTreasuryAccounts(companyId:number):Observable<any>{
    return this.http.get(env.domain+'AccountCategory/ListOfTreasuryAccounts?companyId='+companyId)
  }
  getListOfExpensesAccounts(companyId:number):Observable<any>{
    return this.http.get(env.domain+`AccountCategory/ListOfExpensesAccounts?companyId=${companyId}`)
  }
  getAccountById(id:string):Observable<any>{
    return this.http.get(env.domain+`AccountCategory/GetById?accountId=${id}`)
  }
}
